// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-artists-js": () => import("./../../../src/pages/artists.js" /* webpackChunkName: "component---src-pages-artists-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-schema-js": () => import("./../../../src/pages/schema.js" /* webpackChunkName: "component---src-pages-schema-js" */),
  "component---src-pages-schema-radio-js": () => import("./../../../src/pages/schema-radio.js" /* webpackChunkName: "component---src-pages-schema-radio-js" */),
  "component---src-templates-artist-index-js": () => import("./../../../src/templates/artist/index.js" /* webpackChunkName: "component---src-templates-artist-index-js" */),
  "component---src-templates-page-index-js": () => import("./../../../src/templates/page/index.js" /* webpackChunkName: "component---src-templates-page-index-js" */)
}

